import { IClientAllocationDetailed } from '~/services/api/clientAllocation/types';

const groupClientAllocations = (
  clientAllocation: IClientAllocationDetailed[],
): {
  crisisAllocations: IClientAllocationDetailed[];
  clientAllocations: IClientAllocationDetailed[];
} =>
  clientAllocation.reduce(
    (acc, allocation) => {
      if (allocation.isCrisis) {
        acc.crisisAllocations.push(allocation);
      } else {
        acc.clientAllocations.push(allocation);
      }
      return acc;
    },
    {
      crisisAllocations: [],
      clientAllocations: [],
    },
  );

export default groupClientAllocations;
